import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

// Components
import { Spin, Modal, Form, Row, Col, Alert, Select, Icon, Input, InputNumber } from 'antd';

// Selectors
import { getDeviceListIsLoading, getDeviceList } from '../../data/devices/selectors';
import { getDeviceTypesList, getAllDeviceTypesAreLoading } from '../../data/deviceTypes/selectors';
import { selectedLangageSelector } from '../../data/app/selector';

// Actions

// Constants
import { MODAL_SIZES } from '../../constants/modal';

class SaveEvent extends PureComponent {

    constructor(props){
        super(props);
        this.state = {
            selectedDeviceId: -1
        };
    }

    handleSubmit = () => {
        const { form, onSave } = this.props;

        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            onSave(values);
        });
    };

    handleAlertClose = () => {
        const { form } = this.props;
        form.setFields({
            hasError: {
                value: undefined
            }
        });
    };

    render() {
        const {
            form,
            isShown,
            isLoading = false,
            msgs,
            onCancel,
            deviceList,
            deviceListIsLoading,
            deviceTypesList,
            deviceTypesListIsLoading,
            lang
        } = this.props;
        const { selectedDeviceId } = this.state;
        if(!deviceList || !deviceTypesList) return null;


        const { getFieldValue, getFieldDecorator } = form;
        return (
            <Modal
                key="users-modal-save-event"
                visible={isShown}
                confirmLoading={isLoading}
                width={MODAL_SIZES.MEDIUM}
                title={msgs.training.saveEvent}
                onCancel={onCancel}
                onOk={this.handleSubmit}
                cancelText={msgs.cancel}
                okText={msgs.save}
            >
                <Spin spinning={isLoading} size="large">
                    <Form>
                        {getFieldValue('hasError') && (
                            <Row>
                                <Col xs={24}>
                                    <Alert
                                        message={getFieldValue('hasError')}
                                        type="error"
                                        showIcon
                                        closable
                                        onClose={this.handleAlertClose}
                                    />
                                </Col>
                            </Row>
                        )}

                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.training.selectDevice}>
                                    {getFieldDecorator('device', {
                                        initialValue: -1,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(
                                        <Select
                                            type="text"
                                            dropdownMatchSelectWidth={false}
                                            placeholder={
                                                deviceListIsLoading ? msgs.loading : msgs.select
                                            }
                                            notFoundContent={
                                                !deviceListIsLoading ? (
                                                    <span>
                                                        <Icon type="loading" />
                                                        {` ${msgs.loading}`}
                                                    </span>
                                                ) : (
                                                    <span>{msgs.noData}</span>
                                                )
                                            }
                                            onChange={value => this.setState({selectedDeviceId: value})}
                                        >
                                            <Select.Option value={-1} key={`typ${-1}`}>{msgs.training.addNew}</Select.Option>
                                            {deviceList.filter(item => !item.deleted).map(item => (
                                                <Select.Option value={item.id} key={`typ${item.id}`}>
                                                    {item.name}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        {
                            selectedDeviceId < 0 &&
                            <>
                                <Row gutter={8}>
                                    <Col xs={24}>
                                        <Form.Item label={msgs.homes.detail.deviceName}>
                                            {getFieldDecorator('name', {
                                                initialValue: undefined,
                                                rules: [{ required: true, message: msgs.requiredField }]
                                            })(<Input type="text"/>)}
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Row gutter={8}>
                                    <Col xs={24}>
                                        <Form.Item label={msgs.homes.detail.deviceType}>
                                            {getFieldDecorator('type', {
                                                initialValue: undefined,
                                                rules: [{ required: true, message: msgs.requiredField }]
                                            })(
                                                <Select
                                                    type="text"
                                                    dropdownMatchSelectWidth={false}
                                                    placeholder={
                                                        deviceTypesListIsLoading ? msgs.loading : msgs.select
                                                    }
                                                    notFoundContent={
                                                        !deviceTypesListIsLoading ? (
                                                            <span>
                                                                <Icon type="loading"/>
                                                                {` ${msgs.loading}`}
                                                            </span>
                                                        ) : (
                                                            <span>{msgs.noData}</span>
                                                        )
                                                    }
                                                >
                                                    {deviceTypesList.map(item => (
                                                        <Select.Option value={item.id} key={`typ${item.id}`}>
                                                            {lang === 'zh' ? item.name_zh : (lang === 'sk' ? item.name_sk : (lang === 'de' ? item.name_de : item.name))}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Row gutter={8}>
                                    <Col xs={24}>
                                        <Form.Item label={msgs.homes.detail.deviceCountLabel}>
                                            {getFieldDecorator('count', {
                                                initialValue: 1
                                            })(
                                                <InputNumber
                                                    style={{ width: '100%' }}
                                                    min={1}
                                                    max={4}
                                                />
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </>
                        }
                    </Form>
                </Spin>
            </Modal>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        deviceListIsLoading: getDeviceListIsLoading(state),
        deviceList: getDeviceList(state),
        deviceTypesList: getDeviceTypesList(state),
        deviceTypesListIsLoading: getAllDeviceTypesAreLoading(state),
        lang: selectedLangageSelector(state)
    }),
    {
    }
)(Form.create()(SaveEvent));
